import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LegalLang } from '../../shared/legal-lang-toggle/legal-lang-toggle.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-tos',
    templateUrl: './tos.component.html',
    styleUrls: ['./tos.component.scss'],
    standalone: false
})
export class TOSComponent implements OnInit, OnDestroy {

  // Local to this page — see LegalLangToggleComponent for why the app's LangService
  // is not used here.
  lang: LegalLang = 'en';

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  ngOnInit() {
    document.body.classList.add('background');
    // Supports sharing a French link, e.g. /tos?lang=fr
    if (this.route.snapshot.queryParamMap.get('lang') === 'fr') {
      this.lang = 'fr';
    }
    this.setTitle();
  }

  onLangChange(lang: LegalLang) {
    this.lang = lang;
    this.setTitle();
  }

  // Titled from the page's own language rather than the app's TranslateService,
  // so the toggle and the tab title cannot disagree.
  private setTitle() {
    const name = this.lang === 'fr' ? 'Conditions d\'utilisation' : 'Terms of Service';
    this.titleService.setTitle(`${name} | ${environment.appName}`);
  }

  ngOnDestroy() {
    document.body.classList.remove('background');
  }

}
